<template>
    
   <div>
        <a href="https://www.facebook.com/APS.Emballages/" target="_blank"><img class="mb-2 text-white" src="@/assets/icons/facebook.svg" height="20"  ></a> 
        <a href="https://www.instagram.com/aps_packaging" target="_blank"><img class="mb-2 pl-3" src="@/assets/icons/instagram.svg" height="20" ></a>
        <a href="mailto:hello@aps-shop.tn"><img class="mb-2 pl-3" src="@/assets/icons/email.svg" height="20"></a>              
        <!--a href="https://www.linkedin.com/company/atlas-emballages"><img class="mb-2 pl-3" src="@/assets/icons/linkedin.svg" height="20"></a-->              
   </div>

</template>

<script>
export default ({
    name: "footer-Social"
})
</script>


